import { useSelector } from 'react-redux';
import { selectFilterOptions } from '../CommentState/selectors';

/**
 * Custom hook to get comment count for a specific phase and category
 * @param phaseName - The phase name to match against filter option labels
 * @param categoryName - The category name to match against children labels
 * @returns Object containing totalCommentCount and mentionCommentCount
 */
export const useCommentCount = (phaseName?: string, categoryName?: string) => {
  const filterOptions = useSelector(selectFilterOptions);
  if (!phaseName && !categoryName)
    return {
      totalCommentCount: -1 //Do not exist
    };

  const matchingPhase = filterOptions.find(
    filterOption => filterOption.label === phaseName
  );
  if (!matchingPhase) {
    return {
      totalCommentCount: 0
    };
  }
  // If only phaseName is provided, search at top level only
  if (phaseName && !categoryName) {
    return {
      totalCommentCount: matchingPhase.commentCount || 0
    };
  }

  // If both phaseName and categoryName are provided, search in children
  if (phaseName && categoryName) {
    const matchingCategory = matchingPhase.children?.find(
      child => child.label === categoryName
    );

    if (!matchingCategory) {
      return {
        totalCommentCount: 0
      };
    }

    return {
      totalCommentCount: matchingCategory.commentCount || 0
    };
  }

  // Return default values if parameters are not provided
  return {
    totalCommentCount: -1
  };
};
